import { render, staticRenderFns } from "./QuestionEditPage.vue?vue&type=template&id=af753a62&"
import script from "./QuestionEditPage.vue?vue&type=script&lang=js&"
export * from "./QuestionEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports